<template>
  <v-layout column fill-height fill-width>
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Manage People</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

        <v-spacer></v-spacer>

        <v-btn flat icon @click.native="loadUserList" v-if="!tab">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn flat icon @click.native="loadScreenerList" v-else>
          <v-icon>refresh</v-icon>
        </v-btn>

        <!-- Sets add button to respective dialog based on selected tab -->
        <CreateUserDialog @updateUserList="loadUserList" v-if="!tab"></CreateUserDialog>
        <ScreenerDialog @update="loadScreenerList" v-else></ScreenerDialog>

        <v-tabs
          slot="extension"
          v-model="tab"
          align-with-title
          color="primary"
        >
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-data-table :headers="headers" :items="users" :search="search" :rows-per-page-items="[10,15,25]">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.local.realname }}</td>
              <td>{{ props.item.local.email }}</td>
              <td>{{ props.item.local.lastlogin | moment("MMMM Do YYYY, h:mm a") }}</td>
              <td>{{ props.item.local.roleLevel > 10 ? "Admin" : "User" }}</td>
              <td>
                <v-btn small color="secondary" @click="openManageUserDialog(props.item)">Manage User</v-btn>
                <v-btn small color="error" @click="deleteUser(props.item)">Delete User</v-btn>
              </td>
            </template>

            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <v-data-table :headers="headersScreeners" :items="screeners" :search="search" :rows-per-page-items="[10,15,25]">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.crewid }}</td>
              <td>{{ props.item.name + " " + props.item.hnotes}}</td>
              <td>{{ props.item.loc }}</td>
              <td>
                <v-btn small color="secondary">Screener Profile</v-btn>
                <v-btn small color="error" @click="deleteScreener(props.item)">Remove Screener</v-btn>
              </td>
            </template>

            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>



    </v-card>

    <ManageUserDialog :visible="manageUserDialogOpened" @close="manageUserDialogOpened=false" :user-data="manageUserData" @updated="loadUserList"></ManageUserDialog>
  </v-layout>
</template>

<script>
  import CreateUserDialog from '../../components/dialogs/CreateUserDialog'
  import ScreenerDialog from '../../components/dialogs/ScreenerDialog'
  import ManageUserDialog from '../../components/dialogs/ManageUserDialog'

  export default {
    name: 'ManageUsers',
    components: {
      CreateUserDialog,
      ScreenerDialog,
      ManageUserDialog
    },
    data() {
      return {
        manageUserData: null,
        manageUserDialogOpened: false,
        search: '',
        tab: null,
        items: [
          'users', 'screeners'
        ],
        headers: [{
          text: 'Real Name',
          align: 'left',
          sortable: true,
          value: 'realname'
        },
          {
            text: 'Username',
            align: 'left',
            sortable: true,
            value: 'username'
          },
          {
            text: 'Last Login',
            align: 'left',
            sortable: true,
            value: 'lastlogin'
          },
          {
            text: 'Role',
            align: 'left',
            sortable: true,
            value: 'role'
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false
          }
        ],
        users: [],
        headersScreeners: [
          {
            text: 'Crew ID',
            align: 'left',
            sortable: true,
            value: 'crewid'
          },
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name'
          },
          {
            text: 'Location',
            align: 'left',
            sortable: true,
            value: 'loc'
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false
          }
        ],
        screeners: []
      }
    },
    methods: {
      openManageUserDialog(user){
        this.manageUserDialogOpened = true;
        this.manageUserData = user;
      },
      loadUserList() {
        this.$http.get('/panel/user/list', {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            this.users = response.data
          })
          .catch(e => {
            this.$root.$emit('snackbar', 'Error retrieving user list!')
          })
      },
      loadScreenerList(){
        this.$http.get('/panel/screener', {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            this.screeners = response.data
          })
          .catch(e => {
            this.$root.$emit('snackbar', 'Error retrieving screener list!')
          })
      },
      deleteUser(item) {
        const index = this.users.indexOf(item)
        if (confirm('Are you sure you want to delete this user? (' + item.local.realname + " / " + item.local.email + ')')) {
          this.$http.post('/panel/user/delete', {id: item._id}, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(response => {
              if (response.data.success) {
                this.$root.$emit('snackbar', response.data.msg)
              } else {
                this.$root.$emit('snackbar', response.data.msg)
              }
              this.loadUserList()
            })
            .catch(e => {
              this.$root.$emit('snackbar', e.response.data.msg)
            })

        } else {

        }
      },
      deleteScreener(item) {
        const index = this.screeners.indexOf(item)
        if (confirm('Are you sure you want to delete this screener? (' + item.name + ')')) {
          this.$http.post('/panel/screener/delete', {id: item._id}, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(response => {
              if (response.data.success) {
                this.$root.$emit('snackbar', response.data.msg)
                this.loadScreenerList()
              } else {
                this.$root.$emit('snackbar', response.data.msg)
              }
              this.loadUserList()
            })
            .catch(e => {
              this.$root.$emit('snackbar', e.response.data.msg)
            })

        } else {

        }
      },
    },
    mounted() {
      this.loadUserList()
      this.loadScreenerList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/ManageUsers.vue